import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Suspense, lazy } from "react";

// Common Styling
import "react-toastify/dist/ReactToastify.css";
import 'react-quill/dist/quill.snow.css';
import loadingSVG from "./assets/svg/loading.svg";

// Layout Component
import CircularSearchLayout from "./layout/CircularSearchLayout";
import MainLayout from "./layout/MainLayout";
import ScrollToTop from "./layout/ScrollToTop";
import { ToastContainer } from "react-toastify";
import Home from "./pages/home/Home";
import UkJobs from "./pages/jobs/uk job/UkJobs";
import UkJobsByTitle from "./pages/jobs/uk job/UkJobsByTitle";
import Blog from "./pages/static/Blog";
import BlogDetail from "./pages/static/BlogDetail";
import CategoryBlogs from "./pages/static/CategoryBlogs";
import SEOPageDetails from "./pages/static/seoPage/SEOPageDetails";
import SeoJobDescription from "./pages/static/seoPage/SeoJobDescription";
import SEOPageListing from "./pages/static/seoPage/SEOPageListing";

// Authentication Pages
const Contact = lazy(() => import("./pages/authentication/Contact"));

// Static Pages
const About = lazy(() => import("./pages/static/About"));
const Career = lazy(() => import("./pages/static/Career"));
const Privacy = lazy(() => import("./pages/static/Privacy"));

// Jobs Pages
const UsJobs = lazy(() => import("./pages/jobs/us job/UsJobs"));
const IndianJobs = lazy(() => import("./pages/jobs/india job/IndianJobs"));
const DeJobs = lazy(() => import("./pages/jobs/germany job/DeJobs"));
const FrJobs = lazy(() => import("./pages/jobs/france/FrJobs"));
const AuJobs = lazy(() => import("./pages/jobs/australia/AuJobs"));
const UsJobsByTitle = lazy(() => import("./pages/jobs/us job/UsJobsByTitle"));
const IndianJobsByTitle = lazy(() => import("./pages/jobs/india job/IndianJobsByTitle"));
const DeJobsByTitle = lazy(() => import("./pages/jobs/germany job/DeJobsByTitle"));
const FrJobsByTitle = lazy(() => import("./pages/jobs/france/FrJobsByTitle"));
const AuJobsByTitle = lazy(() => import("./pages/jobs/australia/AuJobsByTitle"));

const JobDescription = lazy(() => import("./pages/jobs/details/JobDescription"));

// Loader Component for Fallback
const Loader = () => (
  <div className="flex-justify-align-center">
    <img src={loadingSVG} alt="loading"/>
  </div>
);



function App() {
  return (
    <Router>
      <Suspense fallback={<Loader />}>
        <ScrollToTop/>
        <Routes>
          <Route element={<MainLayout />}>
            <Route path="/" element={<Home />} />
          </Route>
          <Route element={<CircularSearchLayout />}>
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/career" element={<Career />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />
            <Route path="/blog/category/:category" element={<CategoryBlogs />} />

            <Route path="/jobs" element={<SEOPageListing />} />
            <Route path="/jobs/:slug" element={<SEOPageDetails />} />
            <Route path="/job/description/:jobId" element={<SeoJobDescription />} />

            <Route path="/privacy" element={<Privacy />} />

            <Route path="/remote-jobs-usa" element={<UsJobs />} />
            <Route path="/remote-jobs-india" element={<IndianJobs />} />
            <Route path="/remote-jobs-germany" element={<DeJobs />} />
            <Route path="/remote-jobs-uk" element={<UkJobs />} />
            <Route path="/remote-jobs-australia" element={<AuJobs />} />
            <Route path="/remote-jobs-france" element={<FrJobs />} />

            <Route path="/remote-jobs-usa/:JobTitle" element={<UsJobsByTitle />} />
            <Route path="/remote-jobs-india/:JobTitle" element={<IndianJobsByTitle />} />
            <Route path="/remote-jobs-germany/:JobTitle" element={<DeJobsByTitle />} />
            <Route path="/remote-jobs-france/:JobTitle" element={<FrJobsByTitle />} />
            <Route path="/remote-jobs-australia/:JobTitle" element={<AuJobsByTitle />} />
            <Route path="/remote-jobs-uk/:JobTitle" element={<UkJobsByTitle />} />


            <Route path="job-description-inj/:JobID" element={<JobDescription source="inj"/>} />
            <Route path="job-description-usg/:JobID" element={<JobDescription source="usg"/>} />
            <Route path="job-description-deg/:JobID" element={<JobDescription source="deg"/>} />
            <Route path="job-description-aug/:JobID" element={<JobDescription source="aug"/>} />
            <Route path="job-description-frg/:JobID" element={<JobDescription source="frg"/>} />
            <Route path="job-description-usb/:JobID" element={<JobDescription source="usb"/>} />
            <Route path="job-description-ukb/:JobID" element={<JobDescription source="ukb"/>} />
            <Route path="job-description-inb/:JobID" element={<JobDescription source="inb"/>} />
          </Route>
        </Routes>
      </Suspense>
      <ToastContainer />
    </Router>
  );
}

export default App;
